import type { CivilDate } from '~/models/civilDate'

/** 入札 CSV 取込の Step2 に出す、 受渡日ごとの取込対象件数 (表示用)。 */
export type BidCsvDateCount = { date: string; count: number }

/**
 * Check 応答の受渡日ごとの件数を表示用に整形する (スポット通常入札
 * spot-bid-normal-csv-import.md AC-SPOT-014 / 時間前入札 intraday-csv-import.md
 * AC-BCI-002)。 件数も並び (CSV 中の受渡日初出順) も backend が返した値のまま出し、
 * 画面で行を数え直さない。
 *
 * スポットと時間前の応答は別の proto message だが形は同じなので、 構造で受ける。
 *
 * @param formatDate 受渡日の書式。 件数を見て日付の取り違えに気づけるよう、 同じ画面の
 *   差分プレビューの行の受渡日と同じ書式を、 呼び出し側が渡す。
 */
export const toBidCsvDateCounts = (
  dateCounts: ReadonlyArray<{ targetDate?: CivilDate; count: number }>,
  formatDate: (date: CivilDate | undefined) => string,
): BidCsvDateCount[] =>
  dateCounts.map((c) => ({
    date: formatDate(c.targetDate),
    count: c.count,
  }))
